/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Doc recognition error: file type not supported
 * @export
 * @interface PaxCheckDocumentTypeNotSupported
 */
export interface PaxCheckDocumentTypeNotSupported {
    /**
     * 
     * @type {string}
     * @memberof PaxCheckDocumentTypeNotSupported
     */
    type: string;
}

/**
 * Check if a given object implements the PaxCheckDocumentTypeNotSupported interface.
 */
export function instanceOfPaxCheckDocumentTypeNotSupported(value: object): value is PaxCheckDocumentTypeNotSupported {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckDocumentTypeNotSupportedFromJSON(json: any): PaxCheckDocumentTypeNotSupported {
    return PaxCheckDocumentTypeNotSupportedFromJSONTyped(json, false);
}

export function PaxCheckDocumentTypeNotSupportedFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckDocumentTypeNotSupported {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
    };
}

export function PaxCheckDocumentTypeNotSupportedToJSON(json: any): PaxCheckDocumentTypeNotSupported {
    return PaxCheckDocumentTypeNotSupportedToJSONTyped(json, false);
}

export function PaxCheckDocumentTypeNotSupportedToJSONTyped(value?: PaxCheckDocumentTypeNotSupported | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
    };
}

